module.exports = __webpack_public_path__ + "static/img/image-003.2747aa9a.jpeg";